import moment from 'moment'
import { Cache } from '@src/models/app.types'

const HISTORICAL_CACHE_SETTLE_HOURS = 24

interface DateFilter {
  startDate?: string
  endDate?: string
}

type DailyNutritionCacheEntry = Partial<NonNullable<Cache[string]>>

interface CacheValidationParams {
  cacheEntry?: DailyNutritionCacheEntry
  filter?: DateFilter
}

export const isTrustedHistoricalDailyNutritionCacheEntry = ({
  cacheEntry,
  filter,
}: CacheValidationParams) => {
  const { startDate, endDate } = filter ?? {}

  if (!cacheEntry || !startDate || !endDate) {
    return false
  }

  const startDateMoment = moment(startDate, [moment.ISO_8601, 'YYYY-MM-DD'], true)
  const endDateMoment = moment(endDate, [moment.ISO_8601, 'YYYY-MM-DD'], true)

  if (!startDateMoment.isValid() || !endDateMoment.isValid()) {
    return true
  }

  if (!startDateMoment.isSame(endDateMoment, 'day')) {
    return true
  }

  if (moment().isSame(startDateMoment, 'day')) {
    return false
  }

  const fetchedAtMoment = moment(cacheEntry.fetchedAt, moment.ISO_8601, true)

  if (!fetchedAtMoment.isValid()) {
    return false
  }

  const trustAfter = endDateMoment.endOf('day').add(HISTORICAL_CACHE_SETTLE_HOURS, 'hours')

  return fetchedAtMoment.isSameOrAfter(trustAfter)
}
